import moment from "moment";
import {
  GET_WORK_WITH_US,
  SET_PAGE,
  SET_SEARCH,
} from "../../shared/constants/ActionTypes";

const initialContactUs = {
  workWithUs: [],
  workWithUsCount: 0,
  page: 1,
  search: "",
};

const workWithUsReducer = (state = initialContactUs, action) => {
  switch (action.type) {
    case GET_WORK_WITH_US:
      return {
        ...state,
        workWithUs: action.payload?.workWithUs.map((item) => {
          return {
            ...item,
            name: item?.firstName + " " + item?.lastName,
            updatedAtFormatted: moment(item?.createdAt).format("ll"),
          };
        }),
        workWithUsCount: action.payload?.total,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    default:
      return state;
  }
};

export default workWithUsReducer;
